import type { AdminEnhancedDomain } from 'sunlife-domain'
import { mapStandardProductsToPublishedData } from 'sunlife-domain'

import { configuratorInterface } from '../systems/configurator-interface'

export const mapPublishDataHandler = configuratorInterface.createMapPublishedRevisionDataHandler(props => {
  return mapStandardProductsToPublishedData(props.adminEntity as AdminEnhancedDomain.$Admin)
})
